import * as React from 'react';
import Block from "@layout/Block";
import Slider from "@layout/Slider";
import { PieceSlider } from '@store/index';
import './index.scss';

interface Props {
    piece: PieceSlider;
}


class SliderPiece extends React.Component<Props> {
    render(): JSX.Element {
        const { piece } = this.props;

        return (
            <Block indent="40">
                <Slider>
                    {
                        piece.images.reverse().map((image, index) => (
                            <div className="slider-piece" key={`slider-piece-${index}`}>
                                {
                                    image.video &&
                                    <video width={`${image.video.width}px`}  controls muted poster={image.url}>
                                        <source src={image.video.mp4} type="video/mp4" />
                                        <source src={image.video.webm} type="video/webm" />
                                        <source src={image.video.ogg} type="video/ogg" />
                                    </video>
                                }

                                {
                                    !image.video && <img src={image.url} />
                                }
                                
                                {
                                    image.license &&
                                    <a className="license-link" href={image.license.link}>{image.license.text}</a>
                                }
                            </div>
                        ))
                    }
                </Slider>
            </Block>
        )
    }
}

export default SliderPiece;


// WEBPACK FOOTER //
// ./src/components/layout/pieces/Slider/index.tsx